<template>

  <tr :class="{'box-loading': loading}">
    <td class="text-truncate">{{ value.email }}</td>
    <td class="text-truncate">
      <a
        v-if="value.role_id"
        href="javascript:void(0)"
        @click="showEditModal(value)">{{ value.role_id.name }}</a>
    </td>
    <td class="text-truncate">
      {{ value.created_at ? $d(new Date(value.created_at), 'short') : null }}
    </td>
    <td class="text-truncate">
      <a 
        href="javascript:void(0)" 
        @click="resend()">
        {{ $t('Resend invitation') }}
        </a>
      <a 
        href="javascript:void(0)" 
        @click="remove()">
        {{ $t('Remove') }}
        </a>

      <MemberInviteEdit
        v-if="modal_select"
        :initMemberInvite="modal_select" 
        @hideModal="hideModal()" 
        @deleted="deleted();" 
        @saved="saved();" />
    </td>
  </tr>

</template>

<script>
import config from '@/config'
import MemberInviteEdit from './MemberInviteEdit'
import MemberInviteResendInvite from './MemberInviteResendInvite'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'MemberInvite',
  components: {
    MemberInviteEdit,
    MemberInviteResendInvite,
    Avatar
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      modal_select: false
    }
  },
  computed: {
    profile () {
      return this.$store.getters.getProfile
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.value.user_id.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    showEditModal (value) {
      this.modal_select = value
    },
    hideModal () {
      this.modal_select = false
    },
    deleted () {
      this.$emit('deleted')
      this.hideModal()
    },
    saved (value) {
      this.$emit('saved', value)
      this.hideModal()
    },
    resend () {
      this.loading = true
      this.$store
      .dispatch('resendMemberInvite', this.value._id)
      .then(() => {
        this.loading = false
      })
    },
    remove () {
      this.loading = true
      this.$store
      .dispatch('deleteMemberInvite', this.value._id)
      .then(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.photo {
  margin: -5px 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/Member/MemberInviteItem.vue